import { Chip, Stack } from '@mui/material'
import React from 'react'

interface ChatQuickActionsProps {
    onSelect: (text: string) => void
}

const QUICK_ACTIONS = [
    'What is A/B testing?',
    'Explain statistical significance',
    'How do metrics work?',
    'What is a control group?',
]

export const ChatQuickActions = ({ onSelect }: ChatQuickActionsProps) => (
    <Stack
        direction="row"
        spacing={0.75}
        sx={{
            flexWrap: 'wrap',
            gap: '6px',
            padding: '0 16px 12px 52px',
        }}
        data-test="chat-quick-actions"
    >
        {QUICK_ACTIONS.map((action) => (
            <Chip
                key={action}
                label={action}
                variant="outlined"
                size="small"
                onClick={() => onSelect(action)}
                sx={{
                    fontSize: 12,
                    fontWeight: 500,
                    borderRadius: '16px',
                    borderColor: '#6B7280',
                    color: '#1a2a3a',
                    backgroundColor: '#fff',
                    cursor: 'pointer',
                    '&:hover': {
                        borderColor: 'primary.main',
                        color: 'primary.main',
                        backgroundColor: 'rgba(8, 41, 78, 0.06)',
                    },
                }}
                data-test={`chat-chip-${action.toLowerCase().replace(/\s+/g, '-')}`}
            />
        ))}
    </Stack>
)
